import { render, staticRenderFns } from "./EditorElementMenuList.vue?vue&type=template&id=b7e41dd4&"
import script from "./EditorElementMenuList.vue?vue&type=script&lang=js&"
export * from "./EditorElementMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports